<dx-scroll-view height="100%" class="full-height-scrollable">
    <div class="dx-card content login-wrapper">
        <ng-content></ng-content>
    </div>
</dx-scroll-view>
